import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ISelectHeaderProps } from "../../../interfaces/inputs";
import {
  SelectHeaderContainer,
  SelectHeaderInput,
  TitleSpan,
  SelectHeaderIconContainer,
  SelectHeaderIcon,
  IconWrapper,
} from "./SelectStyles";

const Header: React.FC<ISelectHeaderProps> = ({
  title,
  listOpen,
  onClick,
  isFilterActive,
  iconProps,
  hasFilterInput,
  guestTitle,
  onListFilter,
  initFilterList,
  keyName,
  selectedItemsCount,
}) => {
  const [value, setValue] = useState<string>("");
  const { t } = useTranslation();

  useEffect(() => {
    if (listOpen) return;

    setValue("");
    initFilterList && initFilterList();
  }, [initFilterList, listOpen]);

  const handleContainerClick = () =>
    (!hasFilterInput || (hasFilterInput && !listOpen)) && onClick();

  const onChange = ({ target }) => {
    setValue(target.value);
    onListFilter(target.value);
  };

  const placeholderTitle = useMemo(() => {
    if (listOpen) {
      return t("admin.table.search");
    } else {
      if (selectedItemsCount) return `${title} ${`(${selectedItemsCount})`}`;
      else return title;
    }
  }, [listOpen, t, selectedItemsCount, title]);
  return (
    <SelectHeaderContainer
      isOpen={listOpen}
      isActive={isFilterActive}
      onClick={handleContainerClick}
      keyName={keyName}
    >
      {hasFilterInput ? (
        <SelectHeaderInput
          value={value}
          isActive={isFilterActive}
          onChange={onChange}
          placeholder={placeholderTitle}
        />
      ) : (
        <TitleSpan>
          {title}
        </TitleSpan>
      )}
      <SelectHeaderIconContainer onClick={onClick}>
        <IconWrapper>
          <SelectHeaderIcon {...iconProps} listOpen={listOpen} />
        </IconWrapper>
      </SelectHeaderIconContainer>
    </SelectHeaderContainer>
  );
};

export default Header;
